
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import moment from 'moment-jalaali';
import { mask } from 'vue-the-mask';

@Component({ components: { 'date-picker': VuePersianDatetimePicker }, directives: { mask } })
export default class DatePicker extends Vue {
  @Prop(String) value!: string;
  @Prop(Array) rules: any;
  @Prop(String) elementName: string;
  @Prop(String) label: string;
  @Prop({ default: false, type: Boolean }) disableFuture;
  @Prop({ default: false }) dense: boolean;
  @Prop({ default: 'date' }) type: string;
  @Prop({ type: Boolean, default: false }) disabled;
  @Prop({ type: String, default: null }) min;
  val: any = this.value || '';
  max = null;
  show = false;
  mask: any;

  created() {
    this.mask = {
      mask: this.type === 'dateTime' ? 'PPPP/PP/PP PP:PP' : 'PPPP/PP/PP',
      tokens: {
        P: {
          pattern: /[0-9]|[۰-۹]|[٠-٩]/
        }
      }
    };
    this.max = this.disableFuture ? moment().format('jYYYY/jM/jD') : null;
  }

  @Watch('value')
  async onValueChange(newVal: any, oldVal: any) {
    this.val = newVal;
  }

  @Watch('val')
  async onValChange(newVal: any, oldVal: any) {
    this.$emit('input', newVal);
  }

  get format() {
    return this.type === 'dateTime' ? 'jYYYY/jMM/jDD HH:mm' : 'jYYYY/jMM/jDD';
  }

  get displayFormat() {
    return this.type === 'dateTime' ? 'dddd jDD jMMMM jYYYY HH:mm' : 'dddd jDD jMMMM jYYYY';
  }
}
